import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';
import './Navbar.css';

export default function Navbar() {
  const { count } = useCart();
  const { admin, logout } = useAuth();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [adminMenuOpen, setAdminMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/?search=${encodeURIComponent(searchQuery.trim())}`);
      setMobileMenuOpen(false);
    }
  };

  return (
    <nav className="navbar-shell">
      <div className="shipping-banner">Selected order over $100</div>
      <div className="navbar">
        <div className="navbar-inner">
          <button
            className="mobile-icon-btn mobile-only"
            aria-label="Open menu"
            onClick={() => setMobileMenuOpen((open) => !open)}
          >
            ☰
          </button>

          <Link to="/" className="navbar-brand" onClick={() => setMobileMenuOpen(false)}>
            <span className="brand-mark">
              <span>ANORA</span>
              <small>STORE</small>
            </span>
          </Link>

          <form onSubmit={handleSearch} className="navbar-search">
            <input
              type="text"
              placeholder="Search items..."
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
              className="search-input"
            />
            <button type="submit" className="search-btn">Search</button>
          </form>

          <div className="navbar-links">
            <Link to="/track" className="nav-link">Track Order</Link>
            <Link to="/support" className="nav-link">Support</Link>

            <Link to="/cart" className="nav-link cart-link">
              <span className="cart-icon">🛍️</span>
              Cart
              {count > 0 && <span className="cart-badge">{count}</span>}
            </Link>

            {admin ? (
              <div className="admin-menu">
                <button className="nav-link admin-btn" onClick={() => setAdminMenuOpen(!adminMenuOpen)}>
                  ⚙️ Admin ▾
                </button>
                {adminMenuOpen && (
                  <div className="dropdown">
                    <Link to="/admin" onClick={() => setAdminMenuOpen(false)}>Dashboard</Link>
                    <Link to="/admin/products" onClick={() => setAdminMenuOpen(false)}>Products</Link>
                    <Link to="/admin/promotions" onClick={() => setAdminMenuOpen(false)}>Promos &amp; Sales</Link>
                    <Link to="/admin/security" onClick={() => setAdminMenuOpen(false)}>Security</Link>
                    <Link to="/admin/orders" onClick={() => setAdminMenuOpen(false)}>Orders</Link>
                    <Link to="/admin/support" onClick={() => setAdminMenuOpen(false)}>Support</Link>
                    <button onClick={() => { logout(); setAdminMenuOpen(false); }}>Logout</button>
                  </div>
                )}
              </div>
            ) : (
              <Link to="/admin/login" className="nav-link">Admin</Link>
            )}
          </div>

          <div className="navbar-mobile-actions mobile-only">
            <button
              className="mobile-icon-btn"
              aria-label="Open search"
              onClick={() => setMobileMenuOpen(true)}
            >
              ⌕
            </button>
            <Link to="/cart" className="mobile-icon-btn mobile-cart-link" aria-label="View cart">
              <span className="mobile-cart-icon">🛒</span>
              <span className="mobile-cart-text">Cart</span>
              {count > 0 && <span className="cart-badge mobile-cart-badge">{count}</span>}
            </Link>
          </div>
        </div>

        <div className={`mobile-menu-panel ${mobileMenuOpen ? 'open' : ''}`}>
          <form onSubmit={handleSearch} className="mobile-search-form">
            <input
              type="text"
              placeholder="Search items..."
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
              className="search-input mobile-search-input"
            />
            <button type="submit" className="search-btn mobile-search-btn">Search</button>
          </form>

          <div className="mobile-link-list">
            <Link to="/" onClick={() => setMobileMenuOpen(false)}>Shop Home</Link>
            <Link to="/track" onClick={() => setMobileMenuOpen(false)}>Track Order</Link>
            <Link to="/support" onClick={() => setMobileMenuOpen(false)}>Support</Link>
            <Link to="/cart" onClick={() => setMobileMenuOpen(false)}>Cart</Link>
            {admin ? (
              <>
                <Link to="/admin" onClick={() => setMobileMenuOpen(false)}>Admin Dashboard</Link>
                <Link to="/admin/products" onClick={() => setMobileMenuOpen(false)}>Manage Products</Link>
                <Link to="/admin/promotions" onClick={() => setMobileMenuOpen(false)}>Promos &amp; Sales</Link>
                <Link to="/admin/security" onClick={() => setMobileMenuOpen(false)}>Security</Link>
                <button className="mobile-logout-btn" onClick={() => { logout(); setMobileMenuOpen(false); }}>Logout</button>
              </>
            ) : (
              <Link to="/admin/login" onClick={() => setMobileMenuOpen(false)}>Admin Login</Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}
